// Import layout components
import AppHeader from 'components/AppHeader';
import Channel from 'containers/Channel';
import Detail from 'containers/Detail';
// Import route handlers
import Overview from 'containers/Overview';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { Col, Grid, Row } from 'react-bootstrap';

/**
 * App component
 */
@inject('MediahubStore', 'ViewStore')
@observer
class App extends Component {

  /**
   * Rendering views based on currentView
   */
  renderCurrentView() {
    switch(this.props.ViewStore.currentViewName) {
      case 'overview':
        return <Overview />;
      case 'channel':
        return <Channel />;
      case 'detail':
        return <Detail />;
      default:
        return <h1 >404 - Not found</h1 >;
    }
  }

  render() {
    return (
      <section ref={(ref) => this._container = ref} >
        <Grid fluid={true} className={'appContainer'} >
          {
            !_.isEqual(this.props.ViewStore.currentViewName, 'detail')
              ? (
                <Row >
                  <Col xs={12} >
                    <AppHeader />
                  </Col >
                </Row >
              )
              : null
          }
          <Row >
            <Col xs={12} >
              {this.renderCurrentView()}
            </Col >
          </Row >
        </Grid >
      </section >
    );
  }
}

export default App;
